import React, { useState } from 'react';
import styled, { css } from "styled-components";
import { GlassMagnifier, TOUCH_ACTIVATION } from "react-image-magnifiers";

import { CarouselItem } from '../types/Product';
import { Image } from './Image';
import { Spacing } from '../helpers/layout';
import { TABLET } from '../branding';
import { getImageUrl } from '../helpers/getImageUrl';

type Props = {
  items?: Array<CarouselItem>;
};

const GalleryWrapper = styled.div`
  width: 100%;
`;

const ThumbsImageWrapper = styled.div`
  display: block;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;

  .thumb-img {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
`;

const ImageWrapper = styled(ThumbsImageWrapper as any)`
  opacity: 1;
  transition: opacity .3s;

  &.out {
    opacity: 0;
  }
  @media (max-width: ${TABLET}px) {
    height: auto;

    .thumb-img {
      position: static;
    }
  }
`

function Magnifier(props: { imageUrl: string }) {
  return (
    <GlassMagnifier
      imageSrc={props.imageUrl}
      touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP}
      magnifierSize="250px"
      magnifierBorderSize={3}
      square
      allowOverflow
      className="magnifier"
    />
  );
}


const computeWidth = (width:number, height: number, coeficientHeight: number):number => Math.round(width * coeficientHeight / height);

const ProductGallery:React.FC<Props> = ({items = [] }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0)
  const [currentClass, setCurrentClass] = useState<string>('');

  const thumbHeight = 90;
  const slide = items[currentSlide];

  const animateOutAndIn = (index: number) => {
    setCurrentClass('out');
    setTimeout(() => {
      setCurrentSlide(index);
      setCurrentClass('');
    }, 400)
  };

  return (
    <GalleryWrapper>
      <ImageWrapper
        key={slide.image.value.id}
        css={css`
          padding-bottom: ${(slide.image.value.height * 100 / slide.image.value.width).toFixed(2)}%;

          @media (max-width: ${TABLET}px) {
            padding-bottom: 0;
          }
        `}
        className={currentClass}
      >
        <Magnifier imageUrl={
            getImageUrl(slide.image.value, {
              height: 500,
              devicePixelRatio: 1.25,
            })
          }
        />
      </ImageWrapper>

      <div css={css`margin-top: ${Spacing.m}`}>
        {items.map((item, index) => {
          const width = computeWidth(item.image.value.width, item.image.value.height, thumbHeight) ;

          return (
            <ThumbsImageWrapper
              onClick={() => animateOutAndIn(index)}
              key={item.image.value.id}
              css={css`
                width: ${width}px;
                padding-bottom: ${thumbHeight}px;
                margin-right: ${Spacing.m};
                margin-bottom: ${Spacing.m};
                display: inline-block;
              `}
            >
              <Image
                file={item.image ? item.image.value : null}
                height={thumbHeight}
                className="thumb-img"
              />
            </ThumbsImageWrapper>
          )
        })}
      </div>
    </GalleryWrapper>
  );
}

export default ProductGallery;
